import { render, staticRenderFns } from "./GoogleSearchIntegration.vue?vue&type=template&id=5c65ba30"
import script from "./GoogleSearchIntegration.vue?vue&type=script&lang=js"
export * from "./GoogleSearchIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports